import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateProfileContactRequest } from './updateProfileContact.types';

export async function updateProfileContact(
  data: UpdateProfileContactRequest
): Promise<void> {
  await axiosInstance.put('/client-profiles/contact-information', data);
}
